import React, { FC, PropsWithChildren, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Box } from '@mui/material';

interface ModalPortalProps extends PropsWithChildren { }

const ModalPortal: FC<ModalPortalProps> = ({ children }) => {
  // Prevents scrolling behind the modal prompt
  // Triggers on component render
  // on component cleanup returns previous overflow
  useEffect(() => {
    const html = document.querySelector('html');
    const body = document.querySelector('body');
    if (html)
      html.style.overflow = 'hidden';
    if (body)
      body.style.overflow = 'hidden';
    return () => {
      if (html)
        html.style.overflow = 'unset';
      if (body)
        body.style.overflow = 'unset';
    };
  }, []);

  return (
    <ModalWindow>
      <Box
        sx={{
          position: "fixed",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          backdropFilter: "blur(18px)",
          zIndex: 1299,
        }}>
        {children}
      </Box>
    </ModalWindow>
  )
}

const modalDiv = document.getElementById("modals");

const ModalWindow = (props: any) => {
  return createPortal(props.children, modalDiv!);
};

export default ModalPortal;
